import { apiAxios } from "../apiConfig";

// Get petition count
export const getPetitionCount = async () => {
  try {
    const response = await apiAxios.get("/petition/count");

    return response.data;
  } catch (error) {
    console.error("Error fetching petition count:", error);
    throw error;
  }
};

// Sign petition
export const signPetition = async (payload) => {
  try {
    const response = await apiAxios.post("/petition", payload);
    return response.data;
  } catch (error) {
    console.error("Error signing petition:", error);
    throw error;
  }
};
